export default __webpack_public_path__ + "static/media/floralServiceImg_03.a31cee80.jpg";